import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes and twMerge for Tailwind-specific merging
 * 
 * @param {...any} inputs - Class names to merge
 * @returns {string} - Merged class names
 * 
 * @example
 * cn('px-2 py-1', 'bg-red-500', condition && 'text-white')
 * // Returns: 'px-2 py-1 bg-red-500 text-white' (if condition is true)
 * 
 * @example
 * cn('px-2', 'px-4') // Later classes override
 * // Returns: 'px-4'
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}